<hr>
<div class="container">
  <h3>聯絡我們</h3>
  <div class="row">
    <div id="contact">

      <div id="whatsapp">
        <p style="margin-bottom: 0;"> WHATSAPP : 5574-5771 </p>
        <i class="fab fa-whatsapp"></i>
      </div>
      <p id="phone">
        電話: 2111-0835 <br>
        傳真: 3580-2677 <br>
      </p>
    </div>

    <div id='address'>
      <p>
        地址 - 北角英皇道60號康福園1樓A室 <br>
        港鐵 - 炮台山站A出口 <br>
        電車 - 英皇道木星街站 <br>
        巴士 - 英皇道七海商業中心站
      </p>

      <div class="iframe-container">
        <iframe frameborder="0" style="border:0"
          src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJqRAKugEBBDQROKxFmX5zL6s&key=AIzaSyD6dAdg9gVyRHwSVBeVIEf6SpybhNa9R8o"
          allowfullscreen>
        </iframe>
      </div>
    </div>
  </div>
</div>

<div>
  <footer id="footer-copyright">
    <p class="copyright"> Copyright © 2019 Colin Leung</p>
  </footer>
</div>
